import React from 'react';
import { isLiteView, isStaticMode, parseToBoolean } from '../../utils/general/general';
import UserAgentUtils from '../../utils/general/userAgentUtils';
import { checkDomEntitlement } from '../../utils/general/checkDomEntitlement';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';

interface IAuthorPhoneProps {
    serial: number;
    phone: string;
    isDeaden?: boolean;
    analystId?: string;
    analystFlag?: string;
    displayPhone?: boolean;
}
class AuthorPhone extends React.PureComponent<IAuthorPhoneProps, any> {
    private ANALYST_PHONE = React.createRef<HTMLDivElement>();
    constructor(props: IAuthorPhoneProps) {
        super(props);
    }
    public componentDidMount() {
        this.ANALYST_PHONE.current && checkDomEntitlement(this.ANALYST_PHONE.current);
    }

    public showAuthorPhone() {
        return parseToBoolean(this.props.analystFlag || '');
    }

    public getPhoneLink = (e: { currentTarget: { href: string } }) => {
        if (
            (!this.props.isDeaden && !window.HTML_RENDITION.initialData.isEntitled('ANALYST_PHONE'))
            || !this.props.analystId
        ) {
            return;
        }
        // track author email click
        RSCH_HTML_TRACKING_CONFIG.trackAuthorPhoneClick(this.props.analystId);
        e.currentTarget.href = 'tel:' + this.props.phone;
    };

    public authorPhoneDom() {
        if (!this.showAuthorPhone() || !this.props.displayPhone || isLiteView()) {
            return null;
        }

        if (isStaticMode()) {
            return (
                <div id={'authorPhone' + this.props.serial} className="authorPhone">
                    <a>{this.props.phone}</a>
                </div>
            );
        }

        return (
            (navigator.userAgent.indexOf('Mac') != -1 && !UserAgentUtils.isMobile.iOS()) || this.props.isDeaden)
            ? (
                <div
                    ref={this.ANALYST_PHONE}
                    data-entitlement="ANALYST_PHONE"
                    id={'authorPhone' + this.props.serial}
                    className="authorPhone"
                    data-name={this.props.analystId}
                >{this.props.phone}
                </div>
            )
            : (
                <div
                    ref={this.ANALYST_PHONE}
                    data-entitlement="ANALYST_PHONE"
                    id={'authorPhone' + this.props.serial}
                    className="authorPhone"
                    data-name={this.props.analystId}
                >
                    <a
                        aria-label={this.props.phone}
                        role="link"
                        tabIndex={0}
                        onClick={(e) => this.getPhoneLink(e)}
                    >{this.props.phone}
                    </a>
                </div>
            );
    }

    public render() {
        return this.authorPhoneDom();
    }
}

export default AuthorPhone;
